var _g, _path, _line, _line2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1575_35926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8849 5.55516C15.9146 5.32224 16.2519 5.32224 16.2816 5.55516L16.8948 10.3614C17.183 12.621 18.9622 14.4002 21.2219 14.6885L26.0281 15.3016C26.261 15.3313 26.261 15.6687 26.0281 15.6984L21.2219 16.3115C18.9622 16.5998 17.183 18.379 16.8948 20.6386L16.2816 25.4448C16.2519 25.6778 15.9146 25.6778 15.8849 25.4448L15.2717 20.6386C14.9835 18.379 13.2043 16.5998 10.9446 16.3115L6.13841 15.6984C5.90549 15.6687 5.90549 15.3313 6.13841 15.3016L10.9446 14.6885C13.2043 14.4002 14.9835 12.621 15.2717 10.3614L15.8849 5.55516Z",
    fill: "#FFC266"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8849 6.55516C14.9146 6.32224 15.2519 6.32224 15.2816 6.55516L15.8948 11.3614C16.183 13.621 17.9622 15.4002 20.2219 15.6885L25.0281 16.3016C25.261 16.3313 25.261 16.6687 25.0281 16.6984L20.2219 17.3115C17.9622 17.5998 16.183 19.379 15.8948 21.6386L15.2816 26.4448C15.2519 26.6778 14.9146 26.6778 14.8849 26.4448L14.2717 21.6386C13.9835 19.379 12.2043 17.5998 9.94465 17.3115L5.13841 16.6984C4.90549 16.6687 4.90549 16.3313 5.13841 16.3016L9.94465 15.6885C12.2043 15.4002 13.9835 13.621 14.2717 11.3614L14.8849 6.55516Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5833,
    y1: 8.5,
    x2: 27.5833,
    y2: 8.5,
    stroke: "white",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.0833,
    y1: 11,
    x2: 25.0833,
    y2: 6,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1575_35926",
    x: 0.763745,
    y: 0.18086,
    width: 30.639,
    height: 30.6383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6,
    result: "effect1_foregroundBlur_1575_35926"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.c1ae7d23bdb5f7679880da255e6ac919.svg";
export { ForwardRef as ReactComponent };